function navbarDataLinks(client: string) {
  switch (client) {
    case 'core':
    case 'metro':
    case 'rmr':
    case 'jvm':
    case 'wellspring':
      return [
        {
          link: 'dashboard',
          label: 'Investor Portal',
        },
      ];
    case 'solyco':
      return [
        {
          link: 'salesrep/investors',
          label: 'Sales Rep Portal',
        },
        {
          link: 'dashboard',
          label: 'Investor Portal',
        },
      ];
    default:
      return [
        {
          link: 'current-offerings',
          label: 'Current Offerings',
        },
        {
          link: '#',
          label: 'Investors',
        },
        {
          link: '#',
          label: 'Meet Our Team',
        },
        {
          link: '#',
          label: 'Contact',
        },
        {
          link: 'dashboard',
          label: 'Investor Portal',
        },
        {
          link: 'admin/offerings',
          label: 'Admin Portal',
        },
        {
          link: 'salesrep/investors',
          label: 'Sales Rep Portal',
        },
      ];
  }
}

export default navbarDataLinks;
